import { View, Text, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  header: {
    marginBottom: 20,
    paddingBottom: 15,
    borderBottomWidth: 2,
    borderBottomColor: "#3b82f6"
  },
  title: {
    fontSize: 24,
    fontWeight: "bold",
    color: "#1e3a5f",
    marginBottom: 5
  },
  subtitle: {
    fontSize: 12,
    color: "#6b7280"
  },
  companyInfo: {
    marginTop: 10,
    flexDirection: "row",
    justifyContent: "space-between"
  },
  companyName: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#374151"
  },
  cnpj: {
    fontSize: 10,
    color: "#6b7280"
  },
  porte: {
    fontSize: 10,
    color: "#6b7280"
  }
});

interface HeaderProperties {
  empresaNome: string;
  empresaCnpj: string;
  empresaPorte: string;
  questionarioNome: string;
  projetoNome?: string;
}

/**
 *
 * @param root0
 * @param root0.empresaNome
 * @param root0.empresaCnpj
 * @param root0.empresaPorte
 * @param root0.questionarioNome
 * @param root0.projetoNome
 */
export function Header({ empresaNome, empresaCnpj, empresaPorte, questionarioNome, projetoNome }: HeaderProperties) {
  return (
    <View style={styles.header}>
      <Text style={styles.title}>Relatório de Diagnóstico</Text>
      <Text style={styles.subtitle}>{questionarioNome}</Text>
      {projetoNome && <Text style={styles.subtitle}>{projetoNome}</Text>}

      <View style={styles.companyInfo}>
        <View>
          <Text style={styles.companyName}>{empresaNome}</Text>
          <Text style={styles.cnpj}>CNPJ: {empresaCnpj}</Text>
        </View>
        <View>
          <Text style={styles.porte}>Porte: {empresaPorte}</Text>
        </View>
      </View>
    </View>
  );
}
